$(function () {
  if($('#neos-application').length) {
    // document.addEventListener('Neos.NodeCreated',function (e) {
    //   Typo3Neos.Content.reloadPage();
    // })

    $(document).on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',function () {
      $(window).trigger('resize');
    })
  }
})
